<form class="buscador-gis">
  <mat-form-field class="example-full-width">
    <input
      type="text"
      class="textos-body-small"
      placeholder="Busca por nombre del elemento"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto" />
    <mat-autocomplete
      #auto="matAutocomplete"
      class="buscador-autocomplete-panel"
      [displayWith]="displayFn"
      (optionSelected)="onOptionSelected($event)">
      <cdk-virtual-scroll-viewport
        itemSize="48"
        class="search-viewport"
        [minBufferPx]="200"
        [maxBufferPx]="450">
        <mat-option
          *cdkVirtualFor="let option of filteredOptions | async"
          [value]="option"
          >{{ option.name }} <small>({{ option.type }})</small></mat-option
        >
      </cdk-virtual-scroll-viewport>
    </mat-autocomplete>
    @if (myControl.value) {
      <mat-icon
        class="material-symbols-rounded search-icon close-icon"
        (click)="onClick()"
        matIconSuffix
        >close</mat-icon
      >
    } @else {
      <mat-icon class="material-symbols-rounded search-icon" matIconSuffix
        >search</mat-icon
      >
    }
  </mat-form-field>
</form>
